import type React from 'react';

import { visuallyHidden } from '@mage-ui/styled-system/patterns';
import { VisuallyHidden as MantineVisuallyHidden } from '@mantine/core';

export type VisuallyHiddenProps = {
  children: React.ReactNode;
};

export const VisuallyHidden = ({ children }: VisuallyHiddenProps) => {
  return (
    <MantineVisuallyHidden
      classNames={{
        root: visuallyHidden(),
      }}
    >
      {children}
    </MantineVisuallyHidden>
  );
};
